import React from 'react';
import {
  List,
  ProductCardsList,
  ProductCardStructure,
  Section,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { FENCES_GATES_LIST_MAP } from './fences-gates-section-constants';
import {
  fencesGatesSection,
  fencesGatesSectionContent,
  fencesGatesSectionContentList,
  fencesGatesSectionContentText,
  fencesGatesSectionImage,
  fencesGatesSectionName,
} from './fences-gates-section-styles';

type FencesGatesSectionProps = {
  elementBlock: string;
  fencesType: string;
};

export const FencesGatesSection: React.FC<FencesGatesSectionProps> = ({ elementBlock, fencesType }) => {
  const gatesList = FENCES_GATES_LIST_MAP[fencesType];
  const hasDecorativeHalfPillar =
    fencesType === 'zabory-iz-profnastila' ||
    fencesType === 'modulnye-ograzhdeniya' ||
    fencesType === 'zabory-zhalyuzi';

  return (
    <Section className={fencesGatesSection}>
      <SectionSubTitle margin="s">Ворота и&nbsp;калитки</SectionSubTitle>
      <ProductCardsList
        elementBlock={elementBlock}
        productList={gatesList}
        renderProductCard={({ name, alt, imgSrc }: ProductCardStructure) => (
          <>
            <img
              className={fencesGatesSectionImage}
              alt={alt}
              src={imgSrc}
              title={name}
              width="144"
              height="144"
            />
            <Typography className={fencesGatesSectionName} adaptive={false} size="subtitle" variant="m">
              {name}
            </Typography>
          </>
        )}
        sectionTitle="Ворота и калитки"
      />
      <div className={fencesGatesSectionContent}>
        <Typography adaptive={false} variant="m" size="body_long">
          Мы&nbsp;подготовим расчёт забора с&nbsp;учётом всех необходимых материалов по&nbsp;вашему проекту.
        </Typography>
        <Typography adaptive={false} variant="m" size="body_long">
          Вы&nbsp;получите смету на&nbsp;товары и&nbsp;расчёт стоимости монтажа. Опытная бригада выполнит
          монтаж с&nbsp;учётом всех особенностей объекта и&nbsp;ваших пожеланий.
        </Typography>
        <Typography adaptive={false} className={fencesGatesSectionContentText} variant="m" size="body_long">
          Наши услуги:
        </Typography>
        <List className={fencesGatesSectionContentList} listStyle="disc">
          <li>
            <Typography adaptive={false} variant="m" size="body_long">
              замер
            </Typography>
          </li>
          <li>
            <Typography adaptive={false} variant="m" size="body_long">
              установка забора
            </Typography>
          </li>
          <li>
            {hasDecorativeHalfPillar ? (
              <Typography adaptive={false} variant="m" size="body_long">
                монтаж ворот, калитки и&nbsp;декоративных полустолбов
              </Typography>
            ) : (
              <Typography adaptive={false} variant="m" size="body_long">
                монтаж ворот и&nbsp;калитки
              </Typography>
            )}
          </li>
        </List>
        <Typography adaptive={false} variant="m" size="body_long">
          Все услуги выполняют проверенные мастера от&nbsp;наших партнёров.
        </Typography>
        <Typography adaptive={false} variant="m" size="body_long">
          Доступность услуг уточняйте у&nbsp;специалистов в&nbsp;магазине или онлайн.
        </Typography>
      </div>
    </Section>
  );
};
